import React, {useState} from "react"
import Dialog from "rc-dialog"
import 'rc-dialog/assets/index.css';
import "./index.css"
import ReactDOM from 'react-dom';

const Modal = (props) => {
    let {
        title,
        onClose,
        visible,
        children,
        closable = true,
        maskClosable = true,
        width = 800,
        height = 500,
        mask = true,
        className = ''
    } = props;
    return (
        <Dialog
            width={width}
            height={height}
            title={title}
            closable={closable}
            maskClosable={maskClosable}
            mask={mask}
            onClose={onClose}
            className={className}
            visible={visible}>
            {children}
        </Dialog>
    )
}

const ConfirmElement = (props) => {
    console.log(props);
    let {
        width = "40%",
        height = 300,
        description = "",
        children = null
    } = props;
    let [visible, setVisible] = useState(true)
    let onClose = () => {
        setVisible(false)
        props.destroyFxn()
    }
    return (
        <Dialog
            width={width}
            height={height}
            visible={visible}
            {...props}
            onClose={onClose}
            destroyOnClose={true}
            maskClosable={false}
            className={'confirm-modal'}
            closeIcon={null}>
            {description ? <div style={{marginTop: 10, fontSize: 16}}>{description}</div> : null}
            {children}
        </Dialog>
    )
}

const confirm = (props) => {
    let {onCancel = null, onSubmit = null, cancelText = "No", submitText = "Yes"} = props
    const destroyFxn = () => {
        ReactDOM.render(null, document.getElementById('confirm-dialog'))
    }
    const childProps = (
        <div className={'action-btn-group'} style={{gap: 0, marginTop: 20}}>
            <a className={'btn btn-sm btn-outline-primary'} onClick={() => {
                destroyFxn()
                if (onCancel) {
                    onCancel()
                }
            }}>{cancelText}</a>
            <a className={'btn btn-sm btn-success'} onClick={() => {
                destroyFxn()
                if (onSubmit) {
                    onSubmit()
                }
            }}>{submitText}</a>
        </div>
    )
    let elementA = React.createElement(ConfirmElement, {
        ...props, destroyFxn
    }, childProps)
    return (
        ReactDOM.render(elementA, document.getElementById('confirm-dialog'))
    )
}


export default Modal
Modal.confirm = confirm;
